import { type OfferSellerV1, type OfferV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetSeller = (
  offer: OfferV11,
): OfferSellerV1 | undefined => offer.seller
